<template>
    <div id="wrapper">
        <SidebarView :memacc="true" :memaccVisible="true" :allMemAcc="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />
                <div class="mx-3">
                    <div class="card card-shape home-box">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 class="m-0 fw-bold text-green">All Products</h6>
                                </div>
                                <div>
                                    <b-button v-if="pay_commission" v-b-modal.comission-run  title="Run Commission"
                                        class="btn-sm me-2 akkurate-green-btn">
                                        <span class="akkurate-small">Pay commission <font-awesome-icon
                                                :icon="['fas', 'money-bill']" /></span></b-button>
                                    <b-button title="Export To Excel" @click="exportToExcel"
                                        class="btn-sm akkurate-green-btn">
                                        <span class="akkurate-small"> Export <font-awesome-icon
                                                :icon="['fas', 'file-excel']" /></span></b-button>
                                    <b-button size="sm" title="Re-write" class="btn-sm akkurate-green-btn mx-2"
                                        @click="showMore()" variant="primary"> <span class="akkurate-small">
                                            Refresh <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" /></span>
                                    </b-button>
                                    <b-button class="btn-sm akkurate-green-btn" href="/members/account/create"
                                        variant="primary">
                                        <span class="akkurate-small"> <i class="fas fa-plus"></i> Add Product</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body py-3 default_bg" style="border-bottom: 1px solid rgb(1, 134, 115);">
                            <div class="home-box border border-success  py-1 bg-white">
                                <div class="my-1 row text-center">
                                    <div class="col">
                                        <p class="mb-0 small"><font-awesome-icon :icon="['fas', 'circle']"
                                                class="akkurate-green" />
                                            Total Account Balance <br /><span class="fw-bold">{{
                                                displayNumber(summary.account_balance) }}</span>
                                        </p>

                                    </div>
                                    <div class="col">
                                        <p class="mb-0 small"><font-awesome-icon :icon="['fas', 'circle']"
                                                class="akkurate-danger" />
                                            Total Avaliable Balance <br /><span class="fw-bold">{{
                                                displayNumber(summary.available_balance)
                                                }}</span>
                                        </p>
                                    </div>
                                    <div class="col">
                                        <p class="mb-0 small"><font-awesome-icon :icon="['fas', 'circle']"
                                                class="akkurate-grey rounded-circle" />
                                            Total Cash Colatetral <br /><span class="fw-bold">{{
                                                displayNumber(summary.totalCashColatetral)
                                                }}</span></p>
                                    </div>
                                </div>
                                <hr class="m-0" />
                                <div class="card-body pt-0">
                                    <form @submit.prevent="submitFormFilters()">
                                        <div class="row">
                                            <div class="col-12 col-md-4">
                                                <label class="akkurate-dark small" for="search">Search</label>
                                                <b-form-group id="search" label-for="search" class="akkurate-dark">
                                                    <b-form-input id="search" class="mt-2 field-container fields"
                                                        type="text" v-model="form.filter"
                                                        placeholder="Search by name, code, A/C, phone ...">
                                                    </b-form-input>
                                                </b-form-group>
                                            </div>

                                            <div class="col">
                                                <label class="akkurate-dark small d-none d-lg-block"
                                                    for="account_number">Account number</label>
                                                <b-form-group id="account_number" label-for="account_number"
                                                    class="akkurate-dark">
                                                    <b-form-input id="account_number"
                                                        class="mt-2 field-container fields" type="text"
                                                        v-model="form.account_number"
                                                        placeholder="Enter Account number">
                                                    </b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col mb-2 mb-md-0">
                                                <label class="akkurate-dark small d-none d-lg-block"
                                                    for="type">Status</label>
                                                <multiselect class="mt-2 field-container" v-model="form.status"
                                                    :options="form.status_option">
                                                </multiselect>
                                            </div>
                                            <div
                                                class="d-grid gap-2 col-md-2 mt-auto d-flex align-content-center justify-content-center">
                                                <b-button type="submit"
                                                    class="akkurate-green-btn akkurate-auth-size w-100"><i
                                                        class="fas fa-search me-2"></i>Search</b-button>
                                                <b-button size="sm" v-b-modal.modal-account title="show more filters"
                                                    class="ms-2">
                                                    <i class="fas fa-bars akkurate-small"></i>
                                                </b-button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table_text_size">
                                <b-table striped bordered responsive id="account-table" :busy.sync="isBusy"
                                    :items="rows" :fields="fields" :tbody-tr-class="rowClass" show-empty>
                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>

                                    <template #empty="scope">
                                        <h4 class="text-center small mt-3">{{ scope.emptyText }}</h4>
                                    </template>
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>
                                    <template #cell(status)="data">
                                        <span :class="statusBadge(data.item.status)">{{ data.item.status }}</span>
                                    </template>
                                    <template #cell(account_balance)="data">
                                        <span> {{ institution?.currency_code + ' ' +
                                            displayNumber(data.item.account_balance)
                                        }}</span>
                                    </template>
                                    <template #cell(available_balance)="data">
                                        <span> {{ institution?.currency_code + ' ' +
                                            displayNumber(data.item.available_balance)
                                        }}</span>
                                    </template>
                                    <!-- A custom formatted column -->
                                    <template #cell(customer)="data">
                                        <div>{{ data.item.customer.first_name }} {{ data.item.customer.last_name }}
                                        </div>
                                    </template>
                                    <template #cell(created_at)="data">
                                        <div style="width: 80px;">{{ data.item?.created_at?.split(' ')?.[0] }}
                                        </div>
                                    </template>
                                    <template #cell(actions)="data">
                                        <span class="d-flex">
                                            <account-view :data="data.item"></account-view>
                                            <a title="Edit" class="btn btn-sm akkurate-blue text-white border-0"
                                                :href="`/members/account/${data.item.account_number}/edit`">
                                                <span class="akkurate-small"><font-awesome-icon
                                                        :icon="['fas', 'edit']" /></span>
                                            </a>

                                            <div title="Account Statement" class="dropdown no-arrow">
                                                <a title="Account Statement" v-if="view_entries || view_statement"
                                                    class="btn btn-sm akkurate-gray-btn text-white custom-pointer border-0 dropdown-toggle"
                                                    id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    <span class="akkurate-small"><font-awesome-icon
                                                            :icon="['fas', 'book']" /></span>
                                                </a>
                                                <div class="dropdown-menu shadow animated--fade-in"
                                                    aria-labelledby="dropdownMenu">
                                                    <div class="dropdown-header">Statments</div>

                                                    <a class="dropdown-item" v-if="view_entries"
                                                        v-b-modal="String(data.item?.id + 'statement_preview')">Account
                                                        Entries</a>
                                                    <account-entries :data="data.item"
                                                        :institution="institution"></account-entries>

                                                    <a class="dropdown-item" v-if="view_statement"
                                                        v-b-modal="String(data.item?.id + 'account_statement')">Account
                                                        Statement</a>
                                                        <account-statement :data="data.item"
                                                        :institution="institution"></account-statement>
                                                    <a class="dropdown-item cursor-pointer" v-if="view_statement"
                                                        @click="showAllStatementModal(data.item.customer.id, institution,data.item)">All Statements
                                                    </a>
                                                        
                                                </div>
                                            </div>

                                            <!-- <a title="Merge"
                                                class="btn btn-sm akkurate-danger-btn border-0 text-white custom-pointer"
                                                v-b-modal="'merge' + data.item.id">
                                                <span class="akkurate-small"><font-awesome-icon
                                                        :icon="['fas', 'trash']" /></span>
                                            </a> -->
                                            <a title="Delete"
                                                class="btn btn-sm akkurate-danger-btn border-0 text-white custom-pointer"
                                                @click="confirmDeleteProduct(data.item)">
                                                <span class="akkurate-small"><font-awesome-icon
                                                        :icon="['fas', 'trash']" /></span>
                                            </a>
                                            <!-- <a title="Account Statement" class="btn btn-sm akkurate-gray-btn text-white" v-b-modal="String(props.row?.id + 'account_statement')">
                                                    <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'book']" /></span>
                                                </a> -->
                                            <!-- <account-statement :data="props.row" :institution="institution"></account-statement> -->
                                        </span>
                                    </template>
                                </b-table>
                                <div class="d-flex justify-content-between px-3 pb-3">
                                    <b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
                                        :total-rows="totalRecords" :per-page="perPage"
                                        aria-controls="member-table"></b-pagination>
                                    <div class="col text-end mt-1">
                                        <div>{{ currentPage }} - {{ perPage }} of {{ totalRecords }}</div>
                                        <b-form-group label="Per Page" label-size="sm" class="mb-0">
                                            <b-form-select @change="selectPerPage" id="per-page-select"
                                                v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
                                        </b-form-group>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal size="sm" id="bv-modal-more" hide-footer>
                <template #modal-title>
                    <h6 class="m-0 fw-bold text-green text-sm">More Action</h6>
                </template>
                <div class="row">
                    <div class="col-12 col-md-6 text-center">
                        <b-button class="btn-sm akkurate-green-btn" @click="rewriteAccountEntries" variant="primary">
                            <span v-if="rewriteStatmentLoading">
                                <b-spinner class="align-middle"></b-spinner>
                            </span>
                            <span v-else class="akkurate-small"> Rewrite Statement</span>
                        </b-button>
                    </div>
                    <div class="col-12 col-md-6 text-center">
                        <b-button @click="refreshAvailableBalance" class="btn-sm akkurate-green-btn" variant="primary">
                            <span v-if="avaliableBalanceLoading">
                                <b-spinner class="align-middle"></b-spinner>
                            </span>
                            <span v-else class="akkurate-small"> Update Avalibale Balance</span>
                        </b-button>
                    </div>
                </div>
                <!-- <rewrite-transaction @submitRewrite="submitRewrite"></rewrite-transaction> -->
                <!-- <edit-transaction :coa_edit="coa_edit" :coa_subhead_options="coa_subhead_options"
                @coaSaved="coaSaved"></edit-transaction> -->
            </b-modal>
            <b-modal size="lg" id="modal-account" @ok="handleOk">
                <template #modal-title>
                    <h6 class="fw-bold mb-0 akkurate-green">Filter</h6>
                </template>
                <!-- <transaction-form :form="form" :users="users" :branch_option="branch_option"></transaction-form> -->
                <account-filter :form='form' :filterTable="filterTable"></account-filter>
                <template #modal-footer="{ ok }">

                    <div class="w-100">
                        <!-- Emulate built in modal footer ok and cancel button actions -->
                        <b-button @click="$bvModal.hide('modal-account')" type="button"
                            class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
                                class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
                            </span></b-button>
                        <b-button @click="ok()" type="submit" :disabled="isSaving"
                            class="akkurate-green-btn btn-size float-right border-0"><span
                                class="small"><font-awesome-icon class="me-2"
                                    :icon="['fas', 'search']" />Search</span></b-button>
                    </div>
                </template>
            </b-modal>
            <commission-payment></commission-payment>
            <Footer></Footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
          <all-account-statement :member_id="member_id" :institution="institution" />
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from '@/views/main/components/Sidebar.vue';
import TopbarView from '@/views/main/components/Topbar.vue';
import Footer from '@/views/main/components/Footer.vue';
import AccountFilter from '../forms/AccountFilter.vue'
import ApiService from "@/core/services/api.service";
import AccountStatement from '../statement/AccountStatement.vue';
import AccountEntries from '../entries/AccountEntries.vue';
import AccountView from '../view/AccountView.vue'
import ExcelJS from "exceljs";
import { hasPermission } from '@/helper';
import Multiselect from "vue-multiselect";
import CommissionPayment from '../view/CommissionPayment.vue';
import ChatBot from '@/views/components/AI/ChatBot.vue';
import AllAccountStatement from '../statement/AllAccountStatement.vue';
export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        AccountFilter,
        AccountStatement,
        AccountEntries,
        AccountView,
        Multiselect,
        CommissionPayment,
        AllAccountStatement,
        ChatBot,
    },
    data() {
        return {
            ...this.initialState(),
            member_id: "",
            totalRecords: 0,
            searchFilter: "",
            isLoading: false,
            isSaving: false,
            add_or_edit: 'add',
            institution: "",
            isBusy: true,
            currentPage: 1,
            perPage: 10,
            per_page_options: ['10', '20', '50', '100', '500'],
            view_statement: false,
            view_entries: false,
            avaliableBalanceLoading: false,
            rewriteStatmentLoading: false,
            pay_commission: false,
            summary: {
                available_balance: 0,
                account_balance: 0,
                totalCashColatetral: 0,
            },
            fields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'account_type.name',
                    label: 'Account Type'
                },
                {
                    key: 'account_category',
                    label: 'Account Category',

                },
                {
                    key: 'account_balance',
                    label: 'Current Balance',
                    sortable: true,

                },
                {
                    key: 'available_balance',
                    label: 'Available Balance',
                    sortable: true,

                },
                {
                    key: 'account_number',
                    label: 'Account Number',

                },
                {
                    key: 'customer',
                    label: 'Member Name',

                },
                {
                    key: 'customer.external_code',
                    label: 'Member (Ext.Code)',

                },
                {
                    key: 'customer.mobile',
                    label: 'Member Mobile',

                },
                {
                    key: 'status',
                    label: 'Status',
                },
                {
                    key: 'created_at',
                    label: 'Created',
                },
                {
                    key: 'actions',
                    label: 'Actions',
                },
            ],
            rows: [],
        }
    },
    mounted() {
        this.getAccountDropdown();
        this.loadItems();
        this.getInsistution();
        this.checkPemission();
    },
    methods: {
        showMore() {
            this.$bvModal.show('bv-modal-more')
        },
        showComission() {
            this.$bvModal.show('comission-run')
        },
        checkPemission() {
            this.view_statement = hasPermission('transaction_management_statement');
            this.view_entries = hasPermission('transaction_management_entries');
            this.pay_commission = hasPermission('transaction_management_pay_commission');
            console.log('Permissions:', this.view_statement, this.view_entries, this.pay_commission);
        },
        statusBadge(item) {
            if (item === 'ACTIVE') {
                return 'badge akkurate-green-bg'
            } else if (item === 'CLOSED') {
                return 'badge akkurate-danger-bg'
            } else if (item === 'DORMANT') {
                return 'badge akkurate-danger-bg'
            } else if (item === 'PENDING') {
                return 'badge akkurate-warning-bg'
            } else {
                return 'badge akkurate-warning-bg'
            }
        },
        rowClass() {
            return 'custom-row-height'
        },
        async getAccountDropdown() {
            this.$Progress.start();
            this.isLoading = true;
            await ApiService.get("/accounts/create/dropdown")
                .then((response) => {
                    // console.log(response);
                    this.form.branch_option = response?.data?.branches
                    this.form.acc_types_option = response?.data?.account_types
                    this.isLoading = false;
                    this.$Progress.finish();
                }).catch((error) => {
                    // console.log(error);
                })
        },
        async getInsistution() {
            await ApiService.get('/settings/institution').then((response) => {
                // console.log(response);
                this.institution = response.data.data;
            }).catch((error) => {
                // console.log(error);
            })
        },

        async loadItems() {
            this.isBusy = true;  // Set isBusy to true when data is being loaded

            var branch_id = this.form.branch ? this.form.branch.id : '';
            var acc_id = this.form.acc_types?.map(index => index?.id ?? []);

            this.$Progress.start();  // Start the progress bar

            try {
                const response = await ApiService.post("/accounts/paginate", {
                    "page": this.currentPage,
                    "per_page": this.perPage,
                    "filter": this.form.filter,
                    "branch_id": branch_id,
                    "account_type_id": acc_id,
                    "account_number": this.form.account_number,
                    "start_date": this.form.start_date,
                    "end_date": this.form.end_date,
                    "status": this.form.status // Active, Inactive, etc.
                });

                // Handle response and update table data
                this.isBusy = false;  // Set isBusy to false when the data is loaded
                this.$Progress.finish();  // Finish the progress bar

                this.totalRecords = response.data.meta.total;
                this.summary = response.data.summary;
                this.rows = response.data.data;  // Return data to populate the table
            } catch (error) {
                console.error(error);
                this.isBusy = false;  // Set isBusy to false in case of an error
                this.$Progress.finish();  // Finish the progress bar even if there's an error

                return [];  // Return an empty array in case of error to prevent the table from breaking
            }
        },

        showAllStatementModal(id, institution,dt) {
			this.member_id = id;
            this.institution = institution

            console.log("User: ",dt,id);
			
			this.$nextTick(() => {
				this.$bvModal.show("all_account_statement");
			});
		},

        async confirmDeleteProduct(index) {
            swal.fire({
                title: "Delete Product",
                // text: 'CODE : ' + response.data.transaction.code,
                text: "Are you sure you want to delete this Transaction?",
                confirmButtonColor: "#018673",
                icon: "question",
                type: "input",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: true, // Show the "Cancel" button
                confirmButtonText: "Yes", // Customize the text for the "OK" button
                cancelButtonText: "No", // Text for the custom button
                buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                customClass: {
                    confirmButton: "btn btn-danger modal-btn-width text-white me-2", // Custom class for the "OK" button
                    cancelButton: "btn akkurate-ash modal-btn-width text-white", // Custom class for the custom button
                },
            },
                function (inputValue) {
                    if (inputValue === null) return false;

                    if (inputValue === "") {
                        // swal.showInputError("You need to write something!");
                        return false;
                    }

                    // swal("Nice!", "You wrote: " + inputValue, "success");
                }
            ).then(async (result) => {
                // this.$Progress.start();
                if (result.isConfirmed) {
                    this.isLoading = true;
                    await ApiService.delete(`/accounts/delete/${index.account_number}`)
                        .then((respp) => {
                            toast.fire({
                                icon: "success",
                                title: respp.data.message,
                            });
                            this.loadItems();
                        })
                        .catch((error) => {
                            console.log(error)
                            if (error.response.data.message) {
                                toast.fire({
                                    icon: "error",
                                    title: error.response.data.message,
                                });
                            } else {
                                toast.fire({
                                    icon: "error",
                                    title: "An error occurred",
                                });
                            }
                        })
                        .finally((resp) => {
                            this.isLoading = false;
                        });

                    this.loadItems();
                    // this.$bvModal.hide(String(this.loan_no + this.statement));
                } else if (result.isDismissed) {
                    this.isLoading = false;
                    // this.$Progress.finish();
                }
            });
        },

        navigatePage(index) {
            this.isBusy = true;
            this.currentPage = index;
            this.loadItems()
        },

        selectPerPage(index) {
            this.perPage = index
            this.loadItems()
        },

        filterTable() {
            // console.log(this.form.filter)
            this.loadItems();
        },

        handleOk(bvModalEvent) {
            this.loadItems();
            // Prevent modal from closing
            // bvModalEvent.preventDefault();
            // Trigger submit handler
        },

        submitFormFilters() {
            //this.serverParams.page = 1;
            //currentPage
            // this.updateParams({ page: 1 });

            this.loadItems();
            // this.coa_name = this.form.users.map(index => {
            // 	return `${index.first_name} ${index.surname}`;
            // }).join(', ');
        },

        async exportToExcel() {
            const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
            const imageUrl = "/default_logo.png"; // Path to your image file

            // Institution details
            const institutionName = this.institution.name;
            const institutionMotto = this.institution.motto;
            const institutionAddress = this.institution.address;
            const institutionPhone = this.institution.telephone;
            const institutionEmail = this.institution.email;

            try {
                // Fetch the Excel file from the public URL
                const response = await fetch(fileUrl);
                if (!response.ok) {
                    throw new Error(
                        `Network response was not ok: ${response.statusText}`
                    );
                }
                const arrayBuffer = await response.arrayBuffer();

                // Load the file into ExcelJS
                const wb = new ExcelJS.Workbook();
                await wb.xlsx.load(arrayBuffer);

                // Access the first sheet
                const ws = wb.getWorksheet(1); // Get the first worksheet

                // Add Image to the top of the sheet
                const imageResponse = await fetch(imageUrl);
                const imageBuffer = await imageResponse.arrayBuffer();
                const imageId = wb.addImage({
                    buffer: imageBuffer,
                    extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
                });

                // Insert the image at the top-left corner (row 1, column 1)
                ws.addImage(imageId, {
                    tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
                    ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
                });

                // Insert institution details next to the image (starting at row 1, col 5)
                const institutionDetailsStartCol = 5; // Column where text starts after image
                const institutionDetailsRow = 1; // Row for institution details

                // Add the institution name, address, and phone number
                ws.getCell(`K${institutionDetailsRow}`).value = institutionName;
                ws.getCell(`K${institutionDetailsRow}`).font = { bold: true, size: 14 }; // Bold and bigger font for name

                ws.getCell(`K${institutionDetailsRow + 1}`).value = institutionAddress;
                ws.getCell(`K${institutionDetailsRow + 1}`).font = { size: 12 };  // Regular font size for address

                ws.getCell(`K${institutionDetailsRow + 2}`).value = institutionMotto;
                ws.getCell(`K${institutionDetailsRow + 2}`).font = { size: 12 };  // Regular font size for phone

                ws.getCell(`K${institutionDetailsRow + 3}`).value = institutionPhone;
                ws.getCell(`K${institutionDetailsRow + 3}`).font = { size: 12 };  // Regular font size for phone

                ws.getCell(`K${institutionDetailsRow + 4}`).value = institutionEmail;
                ws.getCell(`K${institutionDetailsRow + 4}`).font = { size: 12 };  // Regular font size for phone

                // Optionally adjust the column width if the text is long
                ws.getColumn('L').width = 50;  // Adjust the width of column D (if necessary)

                // Define header row
                const header = [
                    "Account Type",
                    "Account Category",
                    "Current Balance",
                    "Available Balance",
                    "Account Number",
                    "Member Name",
                    "Member (Ext.Code)",
                    "Member Mobile",
                    "Status",
                    "Created",
                ];



                // Add header row starting from row 13 (or the next row after the image and details)
                const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
                let headerRow = ws.getRow(startingRow);
                headerRow.values = header;
                headerRow.font = { bold: true };
                headerRow.commit(); // Commit the row to the worksheet

                // Add individual data rows
                let currentRow = startingRow + 1;

                // Process each item
                this.rows.forEach(item => {
                    const row = ws.getRow(currentRow);
                    // Map item values to the corresponding header columns
                    row.values = [
                        item.account_type?.name,
                        item.account_category,
                        item.account_balance,
                        item.available_balance,
                        item.account_number,
                        item.customer?.first_name + ' ' + item.customer?.last_name,
                        item.customer?.external_code,
                        item.customer?.mobile,
                        item.status,
                        item.created_at,
                    ];
                    row.commit();
                    currentRow++;
                });
                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                // Create a download link and simulate a click to download the file
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "account_export.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error(
                    "Error fetching, modifying, or downloading the Excel file:",
                    err.message
                );
            }
        },

        async refreshAvailableBalance() {
            this.$Progress.start();
            this.avaliableBalanceLoading = true;
            await ApiService.post("/accounts/available-balance/update")
                .then((response) => {
                    console.log(response);
                    this.avaliableBalanceLoading = false
                    this.$Progress.finish();
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    this.loadItems();
                }).catch((error) => {
                    // console.log(error);
                    this.avaliableBalanceLoading = false
                })
        },

        async rewriteAccountEntries() {
            this.$Progress.start();
            this.rewriteStatmentLoading = true;
            await ApiService.post("/accounts/account-balance/rewrite")
                .then((response) => {
                    console.log(response);
                    this.rewriteStatmentLoading = false
                    this.$Progress.finish();
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    this.loadItems();
                }).catch((error) => {
                    // console.log(error);
                    this.rewriteStatmentLoading = false
                })
        },

        initialState() {
            return {
                form: {
                    branch: {},
                    branch_option: [],
                    acc_types: [],
                    acc_types_option: [],
                    filter: "",
                    account_number: "",
                    start_date: "",
                    end_date: "",
                    status: "",
                    status_option: ['ACTIVE', 'INACTIVE', 'DORMANT', 'CLOSED'],
                },

            };
        },
    }
}

</script>

<style>
/* Customize the pagination page number color */
/* .pagination {
    --bs-pagination-active-bg: rgb(1, 134, 115) !important;
    --bs-pagination-active-border-color: rgb(1, 134, 115) !important;
    --bs-pagination-focus-box-shadow: none !important;
}

.page-link {
    color: rgb(1, 134, 115) !important;
}

.page-link:hover {
    color: rgb(1, 134, 115) !important;
}

.page-link.active,
.active>.page-link {
    color: #fff !important;
} */
</style>
